"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerFooter = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var DrawerContext_1 = require("../DrawerContext");
var styles_1 = require("@mui/material/styles");
var css_1 = require("@emotion/css");
var base_1 = require("@mui/base");
var DrawerFooterClasses_1 = __importStar(require("./DrawerFooterClasses"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        hidden: ['hidden'],
    };
    return (0, base_1.unstable_composeClasses)(slots, DrawerFooterClasses_1.getDrawerFooterUtilityClass, classes);
};
var Root = (0, styles_1.styled)(Box_1.default, {})(function (_a) {
    var _b;
    var backgroundColor = _a.backgroundColor;
    return (_b = {
            width: '100%',
            backgroundColor: backgroundColor
        },
        _b["&.".concat(DrawerFooterClasses_1.default.hidden)] = {
            visibility: 'hidden',
        },
        _b);
});
var DrawerFooterRender = function (props, ref) {
    var _a, _b;
    var defaultClasses = useUtilityClasses(props);
    var classes = props.classes, userClassName = props.className, children = props.children, _c = props.divider, divider = _c === void 0 ? true : _c, 
    // ignore unused vars so that we can do prop transferring to the root element
    /* eslint-disable @typescript-eslint/no-unused-vars */
    backgroundColor = props.backgroundColor, 
    /* eslint-enable @typescript-eslint/no-unused-vars */
    hideContentOnCollapse = props.hideContentOnCollapse, sx = props.sx, otherProps = __rest(props, ["classes", "className", "children", "divider", "backgroundColor", "hideContentOnCollapse", "sx"]);
    var _d = (0, DrawerContext_1.useDrawerContext)().open, drawerOpen = _d === void 0 ? true : _d;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        divider && react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(Root, __assign({ ref: ref, "data-testid": 'blui-drawer-footer', className: (0, css_1.cx)(defaultClasses.root, classes.root, (_a = {}, _a[defaultClasses.hidden] = !drawerOpen && hideContentOnCollapse, _a), (_b = {}, _b[classes.hidden] = !drawerOpen && hideContentOnCollapse, _b), userClassName), backgroundColor: backgroundColor, sx: sx }, otherProps), children)));
};
/**
 * [DrawerFooter](https://brightlayer-ui-components.github.io/react/components/drawer-footer) component
 *
 * The `<DrawerFooter>` is an optional section that renders at the bottom of the `<Drawer>`. It can be used to add any custom content (as children).
 */
exports.DrawerFooter = react_1.default.forwardRef(DrawerFooterRender);
exports.DrawerFooter.displayName = 'DrawerFooter';
exports.DrawerFooter.propTypes = {
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        hidden: prop_types_1.default.string,
    }),
    backgroundColor: prop_types_1.default.string,
    divider: prop_types_1.default.bool,
    hideContentOnCollapse: prop_types_1.default.bool,
};
exports.DrawerFooter.defaultProps = {
    classes: {},
    divider: true,
    hideContentOnCollapse: true,
};
